module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof25"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("An officer’s marital status was closely connected to his finances and property. A Russian serving in the military did not need his parents’ consent to marry, but only the permission of his commanding officer. However, insufficient military salaries prevented them from marrying until retirement. As a result, an overwhelming majority of Russian officers (91.3%) were single. They usually married in their late 30s and had one or two children.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd5f3b90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof25.vue
// module id = 168
// module chunks = 0